import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Eyebrow, Reveal } from "@/components/Primitives";

const QA = [
  ["What types of businesses do you work with?", "Retail stores, restaurants, online shops, mobile and field-service businesses, professional services and more. If you accept cards, we can help."],
  ["How does the free statement review work?", "After you request a quote, we'll explain how to share your most recent merchant statement. We break down every fee and show you what you're actually paying — no obligation."],
  ["Can I keep my current POS equipment?", "Often, yes. Many existing terminals can be reprogrammed. If yours can't, we'll recommend options that fit your counter, website or mobile setup."],
  ["How quickly can I get set up?", "Timelines depend on approval and equipment, but we'll give you a clear plan in your proposal and walk you through every step."],
  ["Do I have to use your payroll to get card processing?", "No. Payroll is optional. Many owners like having one partner for both, but you can choose either service on its own."],
  ["How soon will someone contact me?", "You'll get an email confirmation right away, and a specialist will respond within 48 hours."],
];

export const FAQ = () => (
  <section id="faq" className="py-24 lg:py-36" data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 grid lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <Eyebrow>06 — Questions</Eyebrow>
        <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-[1.04]">
          Straight <span className="font-serif-i text-[var(--cobalt)]">answers.</span>
        </h2>
      </Reveal>
      <Reveal className="lg:col-span-8" delay={0.1}>
        <Accordion type="single" collapsible className="border-t border-slate-300">
          {QA.map(([q, a], i) => (
            <AccordionItem key={q} value={`q${i}`} className="border-slate-300">
              <AccordionTrigger data-testid={`faq-trigger-${i}`} className="py-6 text-left font-display text-lg sm:text-xl font-medium hover:no-underline hover:text-[var(--cobalt)]">
                {q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-slate-600 leading-relaxed pb-6">{a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
